import React from 'react';
import { Section } from 'src/components/Section';
import { TypicalDayLarge, TypicalDaySmall } from './index';
import { useMediaQueries } from 'src/utils/MediaQueries';
import { mediaQueries } from 'src/style/breakpoints';

const TypicalDay = React.memo(({ id }) => {
  const mqs = useMediaQueries();
  return (
    <Section
      theme="dark"
      id={id}
      css={{
        overflow: 'hidden',
        paddingBottom: 0,
        // paddingTop: 0,
        [mediaQueries.phoneOnly]: {
          paddingTop: 0,
          paddingBottom: 0,
        },
        [mediaQueries.desktopUp]: {
          // paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      {mqs.tabletLandscapeUp ? <TypicalDayLarge /> : <TypicalDaySmall />}
    </Section>
  );
});
export default TypicalDay;
